import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class CultureConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	getDefaultCultureCode(): string {
		return this.configService.get((x) => x.core.culture.defaultCultureCode, "sv-SE");
	}

	/**
	 * Contains culture codes which should be kept specific in hreflang.
	 * ```ts
	 * ["sv-SE"]
	 * ```
	 * @return string[]
	 */
	getHreflangCultureCodes(): string[] {
		return this.configService.get((x) => x.core.culture.hreflangCultureCodes, []);
	}

	/**
	 * Contains culture codes which will not be included in the alternative link generation
	 * ```ts
	 * ["fi-FI"]
	 * ```
	 * @return string[]
	 */
	getHiddenHreflangCultureCodes(): string[] {
		return this.configService.get((x) => x.core.culture.hiddenHreflangCultureCodes, []);
	}

	getXDefaultDisabled(): boolean {
		return this.configService.get((x) => x.core.culture.xDefaultDisabled, false);
	}
}
